import { render, staticRenderFns } from "./EhliyetCard.vue?vue&type=template&id=828aa040&scoped=true"
import script from "./EhliyetCard.vue?vue&type=script&lang=ts"
export * from "./EhliyetCard.vue?vue&type=script&lang=ts"
import style0 from "./EhliyetCard.vue?vue&type=style&index=0&id=828aa040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828aa040",
  null
  
)

export default component.exports